<template>
  <div class="account-pending">
    <div class="account-pending__card">
      <h1 class="account-pending__title">{{ ACCOUNT_PENDING_TITLE }}</h1>
      <p class="account-pending__body">{{ ACCOUNT_PENDING_BODY }}</p>
      <router-link to="/profile" class="btn btn-primary-modern">Личный кабинет</router-link>
    </div>
  </div>
</template>

<script>
import { ACCOUNT_PENDING_BODY, ACCOUNT_PENDING_TITLE } from '@/constants/userMessages';

export default {
  name: 'AccountPendingPage',
  data() {
    return {
      ACCOUNT_PENDING_TITLE,
      ACCOUNT_PENDING_BODY,
    };
  },
};
</script>

<style scoped>
.account-pending {
  max-width: 640px;
  margin: 3rem auto;
  padding: 0 1rem;
}
.account-pending__card {
  background: #fff;
  border: 1px solid var(--tcp-color-border, #dee2e6);
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
}
.account-pending__title {
  font-size: 1.5rem;
  margin-bottom: 0.75rem;
}
.account-pending__body {
  color: #6c757d;
  margin-bottom: 1.25rem;
}
</style>
